// ═══════════════════════════════════════════════════════════════════
//  modules/erp/audit.js
//  invActionLabel · invStatusColors
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

// ── Audit des actions d'inventaire ──
export function invActionLabel(a) {
  const m = { REMOVE_SLOT: "Vider slot", SET_AMOUNT: "Définir quantité", CLEAR_ALL: "Tout vider" };
  return m[a] || a;
}

export function invStatusColors(s) {
  if (s === "done") return { bg: THEME.emeraldDim, col: THEME.emerald };
  if (s === "error") return { bg: THEME.redDim, col: THEME.red };
  return { bg: THEME.amberDim, col: THEME.amber };
}
